import React from "react";
import Col from "../Flex/Col";
import Row from "../Flex/Row";
import { useClasses, Container, Authenticator } from "../..";
const styles = (theme) => ({
    wrapper: {
        [theme.breakpoints.up("md")]: {
            height: "100vh !important",
        },
    },
});
export default function SingelPageAuth(props) {
    const classes = useClasses(styles);
    const { session, setSession, translationGroup } = props;
    return (React.createElement(Container, null,
        React.createElement(Row, { horizontalAlign: "center", verticalAlign: "center", override: { row: classes.wrapper } },
            React.createElement(Col, { md: "rest-fixed" }, props.children),
            React.createElement(Col, { md: "400px" },
                React.createElement(Authenticator, { session: session, setSession: setSession, translationGroup: translationGroup })))));
}
